export enum AudioSfx {
  BUBBLE_APPEAR = 'bubbleAppear',
  BUBBLE_POP = 'bubblePop',
  BUBBLE_REDUCE = 'bubbleReduce',
  BUBBLE_WEAKEN = 'bubbleWeaken',
}
